import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import VideoCard from '../components/VideoCard';

const Watchlist = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [watchlist] = useState([
    {
      id: '1',
      title: 'The Power of Faith',
      description: 'Inspiring journey of spiritual awakening',
      thumbnail: 'https://via.placeholder.com/300x400?text=Faith',
      poster: 'https://via.placeholder.com/1920x1080?text=The+Power+of+Faith',
      duration: '1:45:30',
      rating: 4.8,
      category: 'Religious',
      views: '1.2M',
    },
    {
      id: '2',
      title: 'Grace Unfolding',
      description: 'A powerful story of redemption and grace',
      thumbnail: 'https://via.placeholder.com/300x400?text=Grace',
      poster: 'https://via.placeholder.com/1920x1080?text=Grace+Unfolding',
      duration: '2:10:15',
      rating: 4.9,
      category: 'Drama',
      views: '2.5M',
    },
  ]);

  return (
    <div className="p-4 md:p-8 max-w-7xl mx-auto">
      <SEO 
        title="My Watchlist - Christian Videos"
        description="Your personal watchlist of Christian videos."
        url="https://christianvideos.in/watchlist"
      />
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl md:text-4xl font-bold mb-2">My Watchlist</h1>
        <p className="text-gray-400">{watchlist.length} videos saved</p>
      </div>

      {/* Watchlist Grid */}
      {watchlist.length > 0 ? (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
          {watchlist.map((video) => (
            <VideoCard
              key={video.id}
              video={video}
              onClick={() => navigate(`/video/${video.id}`)}
            />
          ))}
        </div>
      ) : (
        <div className="text-center py-16">
          <p className="text-2xl font-bold text-gray-400 mb-2">Your watchlist is empty</p>
          <p className="text-gray-500 mb-6">Add videos to your watchlist to watch later</p>
          <button
            onClick={() => navigate('/')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-lg font-semibold transition"
          >
            Explore Videos
          </button>
        </div>
      )}
    </div>
  );
};

export default Watchlist;
